import type { App } from 'vue'
import { useErrorDialogService } from '@/services/ErrorDialogService.ts'

export default {
  install: (app: App) => {
    const { errorHandler, setup } = useErrorDialogService()

    const previousHandler = app.config.errorHandler

    app.config.errorHandler = (err, instance, info) => {
      // 1. Dein eigener Fehlerdialog
      errorHandler(err, instance, info)

      // 2. Ursprünglicher Handler (z.B. von Sentry oder Vue)
      if (typeof previousHandler === 'function') {
        previousHandler(err, instance, info)
      } else {
        // 3. Fallback: Standard-Logging, falls kein vorheriger Handler
        console.error(err)
      }
    }

    setup()
  }
}
